/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiPetAttributeEligibility,
  ApiPetAttributeEligibilityFromJSON,
  ApiPetAttributeEligibilityFromJSONTyped,
  ApiPetAttributeEligibilityToJSON,
} from './ApiPetAttributeEligibility';

/**
 * holds various criteria for a specific Pet Profile to be eligible for current MI
 * @export
 * @interface ApiPetEligibility
 */
export interface ApiPetEligibility {
  /**
   *
   * @type {string}
   * @memberof ApiPetEligibility
   */
  type?: ApiPetEligibilityTypeEnum;
  /**
   *
   * @type {ApiPetAttributeEligibility}
   * @memberof ApiPetEligibility
   */
  attributes?: ApiPetAttributeEligibility;
}

/**
 * @export
 */
export const ApiPetEligibilityTypeEnum = {
  Dog: 'dog',
  Cat: 'cat',
  Fish: 'fish',
  Bird: 'bird',
  SmallPet: 'small-pet',
  Reptile: 'reptile',
  Horse: 'horse',
  FarmAnimal: 'farm-animal',
} as const;
export type ApiPetEligibilityTypeEnum = typeof ApiPetEligibilityTypeEnum[keyof typeof ApiPetEligibilityTypeEnum];

export function ApiPetEligibilityFromJSON(json: any): ApiPetEligibility {
  return ApiPetEligibilityFromJSONTyped(json, false);
}

export function ApiPetEligibilityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetEligibility {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    type: !exists(json, 'type') ? undefined : json['type'],
    attributes: !exists(json, 'attributes')
      ? undefined
      : ApiPetAttributeEligibilityFromJSON(json['attributes']),
  };
}

export function ApiPetEligibilityToJSON(value?: ApiPetEligibility | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    type: value.type,
    attributes: ApiPetAttributeEligibilityToJSON(value.attributes),
  };
}
